import { render, staticRenderFns } from "./EditRequestComponent.vue?vue&type=template&id=995a5a22&"
import script from "./EditRequestComponent.vue?vue&type=script&lang=js&"
export * from "./EditRequestComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports